import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'
import { UrlBuilder } from '../helpers'

export const getSuburbs = async (params) => {
  return await apiCall(UrlBuilder(apis.SUBURB_DATABASE, params))
}

export const suburbsAutocomplete = async (params) => {
  return await apiCall(UrlBuilder(apis.SUBURBS_AUTOCOMPLETE, params))
}
